import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const optionInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class OptionApi {  

	static OptionInsert(payload) {
		optionInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return optionInstance.post('/option', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static OptionUpdate(payload, id) {
		optionInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return optionInstance.patch(`/option/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static OptionList() {
		optionInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return optionInstance.get('/option')
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static OptionDelete(id) {
		optionInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return optionInstance.delete(`/option/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

}

export default OptionApi; 


